import React from 'react';
import {useNavigate} from 'react-router-dom';
import undo from '../../assets/undo.png';
import './ReturnButton.css'

const ReturnButton = ({title, text, link, states}) => {

    const navigate = useNavigate();

    const navigateHome = () => {
        navigate(link, {state : states});
      };

    return (
        <div className='header'>
            <span>
                <img src={undo} style={{width : "40px"}} onClick={navigateHome}/>
                <span style={{marginLeft:"1rem"}} onClick={navigateHome}>Retour à l'accueil</span>
            </span>

                <p>{text}</p>
                <h1>{title}</h1>
        </div>
        
    );
};

export default ReturnButton;